<template>
  <b-container fluid>
    <b-row>
      <b-col cols="8">
        <h3>
          <b-badge variant="primary">
            Household visits
          </b-badge>
          <b-spinner small v-if="waiting" class="align-middle"></b-spinner>
        </h3>
      </b-col>
      <b-col>
        <b-button
          block
          @click="$router.push({path: `/householddetails/${HHID}`})">
          Household Details
        </b-button>
      </b-col>
      <b-col>
        <b-button
          block
          @click="$router.go(-1)">
          Back
        </b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-table 
          small
          responsive
          striped
          stacked="sm"
          class="mt-4"
          :busy="waiting"
          :items="items" 
          :fields="fields">
          <div slot="table-busy" class="text-center text-danger">
            <b-spinner class="align-middle"></b-spinner>
            <!-- <strong>Loading...</strong> -->
          </div>
        </b-table>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { apiService } from '../_services'

export default {
  name: 'HouseholdVisits',
  data() {
    return {
      waiting: false,
      HHID: '',
      items: [],
      fields: [
        {
          key: 'HHID',
          label: 'HH ID'
        },
        {
          key: 'ClaimID',
          label: 'Claim ID'
        },
        {
          key: 'FamilyName',
          label: 'Family Name'
        },
        {
          key: 'Date',
          label: 'Date'
        },
        {
          key: 'Outcome',
          label: 'Outcome'
        },
        {
          key: 'Interviewer',
          label: 'Interviewer'
        },
      ]
    }
  },
  created() {
    this.HHID = this.$route.params.hhid
    let vm = this
    this.waiting = true
    apiService.getHouseholdVisits(this.HHID)
    .then((response) => {
      vm.items = response.data
      vm.waiting = false
    })
  }
}
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/HouseholdVisitsPage.vue